import sendMail from "./callback-send";

export default function CallbackForm() {

  const validateName = (name) => {
    if (name.length >= 2 && name.length < 50) {
      return name.match(
        /^[а-яА-Яa-zA-Z]/
      );
    }
  }

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  const validatedName = function() {
    const name = $(this).val();

    if (validateName(name)) {
      $(this).removeClass('not-valid').addClass('filled');
    } else {
      $(this).addClass('not-valid').addClass('filled');
    }
    if (name == '') {
      $(this).removeClass('not-valid').removeClass('filled');
    }
    return false;
  }

  const validatedEmail = function() {
    const email = $(this).val();

    if (validateEmail(email)) {
      $(this).removeClass('not-valid');
      $(this).addClass('filled');
    } else {
      $(this).addClass('filled');
      $(this).addClass('not-valid');
    }
    if (email == '') {
      $(this).removeClass('not-valid').removeClass('filled');
    }
    return false;
  }

  $('input[name="name"]').on('input', function() {
    validatedName.call(this);
  });
  $('input[name="email"]').on('input', function() {
    validatedEmail.call(this);
  });

  function sendCallbackForm() {
    let form = $('.callback__form');
    let button = $('.callback__form').find('button[type="submit"]');
    let timer = 0;
    button.on('click', function() {
      Array.from($('input')).forEach(function(input) {
        if ($(input).val() == '') {
          $(input).addClass('not-valid');
        } else {
          $(input).removeClass('not-valid');
        }
      });
    });
    if (form) {
      form.on('submit', function(e) {
        e.preventDefault();
        if (
          !$('input[name="name"]').hasClass('not-valid') &&
          !$('input[name="email"]').hasClass('not-valid')) {
          sendMail(form).then(function() {
            button.parent().get(0).reset();
            $('input').removeClass('not-valid');
            $('input').removeClass('filled');
            button.text('Отправлено!')
            timer = setTimeout(function() {
              button.text('Отправить заявку')
              clearTimeout(timer);
            }, 2000);
          });
        }
      });
    }
  }
  sendCallbackForm();

}
CallbackForm();
